import { createContext, useContext, useReducer } from "react";

import type {
  GroupByDateFilterAction,
  MergeActions,
  PatientFilterAction,
} from "../reducer";
import { filterReducer } from "../reducer";
import type { GeneralFilterSchema } from "../schema";

type HomepageFilterActions = MergeActions<
  [PatientFilterAction, GroupByDateFilterAction]
>;

interface FilterContextType {
  filter: GeneralFilterSchema;
  dispatch: React.Dispatch<HomepageFilterActions>;
}

const GeneralFilterContext = createContext<FilterContextType | undefined>(
  undefined,
);

const initialGeneralFilter: GeneralFilterSchema = {
  groupId: undefined,
  groupBy: "week",
  gender: undefined,
  age: undefined,
  area: undefined,
};

const generalFilterReducer = (
  state: GeneralFilterSchema,
  action: HomepageFilterActions,
) => {
  if (action.type === "RESET_FILTER") {
    return initialGeneralFilter;
  }

  return filterReducer(state, action);
};

export const useGeneralFilter = () => {
  const context = useContext(GeneralFilterContext);
  if (!context) {
    throw new Error(
      "useGeneralFilter must be used within a GeneralFilterContext",
    );
  }
  return context;
};

export const GeneralFilterProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [filter, dispatch] = useReducer(
    generalFilterReducer,
    initialGeneralFilter,
  );

  return (
    <GeneralFilterContext.Provider value={{ filter, dispatch }}>
      {children}
    </GeneralFilterContext.Provider>
  );
};
